module.exports = __webpack_public_path__ + "static/media/slide_1.5b83ad8f.webp";